'use client';

import Image from 'next/image';
import { cn } from '@/lib/utils';

interface ClientLogo {
  src: string;
  alt: string;
  href: string;
}

const LogoCard = ({ src, alt, href }: ClientLogo) => {
  return (
    <a 
      href={href} 
      target="_blank" 
      rel="noopener noreferrer"
      className="group relative h-24 w-full flex items-center justify-center p-4 transition-all hover:opacity-80"
    >
      <Image
        src={src}
        alt={alt}
        width={160}
        height={80}
        unoptimized
        className="h-auto w-auto max-h-full max-w-full object-contain"
      />
    </a>
  );
};

export default function ClientSection({ logos }: { logos: ClientLogo[] }) {
  if (!logos || logos.length === 0) return null;

  return (
    <section className="container mx-auto py-16 px-4">
      <h2 className="text-3xl font-bold text-left mb-12 text-foreground tracking-tight">
        Clients
      </h2>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6 md:gap-10">
        {logos.map((logo, index) => (
          <LogoCard key={`${logo.alt}-${index}`} {...logo} />
        ))}
      </div>
    </section>
  );
}
